import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


export function AwaitPaymentModal({ isOpen, messageTitle, showContentAction, ContentAction, title, onHide }) {



    return (
        <div>

            <Dialog
                disableEscapeKeyDown={true}
                open={isOpen}
                onClose={onHide}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={'xs'}
                fullWidth={true}
            >
                <DialogTitle style={{ fontWeight: 'bolder', fontFamily: 'GT Walsheim Pro' }} id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText style={{ color: 'grey', fontFamily: 'GT Walsheim Pro' }} id="alert-dialog-description">
                        {messageTitle}
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    {showContentAction && (ContentAction)}
                </DialogActions>
            </Dialog>

        </div>
    );
}